<template>
  <div>
    <pl-dialog :size="'lg'">
      <!-- HEADER -->
      <div class="flex justify-between px-4 py-3">
        <div class="flex items-center">
          <div
            class="avatar-circle center"
            :style="{
              backgroundImage: 'url(' + encodeURI(user.avatar_url) + ') ',
              'background-size': 'cover',
              'background-position': 'center',
            }"
          ></div>
          <span class="pl-headline ph3"> {{ user.name }}</span>
        </div>
        <pl-button class="pl-icon" @click.native="$emit('close')">
          <i class="fas fa-close" />
        </pl-button>
      </div>

      <!-- TABS -->
      <body class="flex-grow overflow-y-auto px-4 pb-3">
        <pl-tabs
          :tabs="tabs"
          :initialTab="initialTab"
          :minHeight="'400px'"
          :headerWidth="'72%'"
        >
          <!-- Details Tab -->
          <template slot="tab-head-Details">
            <span class="tab-title f1">Details</span>
          </template>
          <!-- Details Content -->
          <template slot="tab-panel-Details">
            <details-tab-content
              :user="user"
              :userId="userId"
              :schoolSites="schoolSites"
              @update-user-email="updateUserEmail"
            ></details-tab-content>
          </template>

          <!-- Courses Tab -->
          <template slot="tab-head-Courses">
            <span class="tab-title">Courses </span>
          </template>
          <!-- Courses Content -->
          <template slot="tab-panel-Courses">
            <courses-tab-content
              :user="user"
              :systemWide="systemWide"
            ></courses-tab-content>
          </template>

          <!-- Portfolio Tab -->
          <template v-if="user.role === 'teacher'" slot="tab-head-Portfolio">
            <span class="tab-title" v-if="user.role === 'teacher'"
              >Portfolio
            </span>
          </template>
          <!-- Portfolio Content -->
          <template v-if="user.role === 'teacher'" slot="tab-panel-Portfolio">
            <portfolio-tab-content :user="user"></portfolio-tab-content>
          </template>
        </pl-tabs>
      </body>
    </pl-dialog>
  </div>
</template>
<script>
  import { mapGetters } from 'vuex';
  import DetailsTabContent from './detailsTabContent.vue';
  import CoursesTabContent from './coursesTabContent.vue';
  import PortfolioTabContent from './portfolioTabContent.vue';
  import { EventBus } from 'utils/event-bus';

  export default {
    computed: {
      ...mapGetters(['getProfile']),
      tabs() {
        if (this.user.role === 'teacher') {
          return ['Details', 'Courses', 'Portfolio'];
        } else {
          return ['Details', 'Courses'];
        }
      },
    },
    components: { DetailsTabContent, CoursesTabContent, PortfolioTabContent },
    data() {
      return {
        initialTab: 'Details',
        user: {},
        schoolSites: [],
      };
    },
    props: {
      userId: {
        type: String,
        default() {
          return '';
        },
      },
      userSchool: {
        type: String,
        default() {
          return '';
        },
      },
      systemWide: {
        type: Boolean,
        default() {
          return false;
        },
      },
    },
    methods: {
      getUserDetails() {
        const schoolID = this.userSchool;
        if (schoolID && this.userId) {
          return this.$store
            .dispatch('getSchoolUserDetails', {
              schoolID: schoolID,
              userID: this.userId,
            })
            .then((userData) => {
              this.user = userData;
              this.user.portfolio = userData.premades;
              this.user.schoolID = schoolID;
              if (userData.user_school[0].school_site_id) {
                this.user.schoolSite = this.schoolSites.find(
                  (s) => s.id === userData.user_school[0].school_site_id
                );
              }
              return this.user;
            });
        } else {
          return this.$store
            .dispatch('getUserDetails', {
              userID: this.userId,
            })
            .then((userData) => {
              this.user = userData;
              this.user.portfolio = userData.premades;
              return this.user;
            });
        }
      },
      updateUserEvent() {
        EventBus.$on('update-userDetails-event', (user) => {
          this.user = user;
        });
      },
      getUserCourses() {
        const schoolID = this.userSchool;
        if (this.userId) {
          if (this.systemWide) {
            this.$store
              .dispatch('getUserCourses', {
                userID: this.userId,
              })
              .then((userCourses) => {
                this.user.courses = userCourses;
              });
          } else {
            if (schoolID) {
              this.$store
                .dispatch('getSchoolUserCourses', {
                  schoolID,
                  userID: this.userId,
                })
                .then((userCourses) => {
                  this.user.courses = userCourses;
                });
            }
          }
        }
      },
      loadSitesOfSchool() {
        const school_id = this.userSchool;
        if (school_id) {
          this.$store
            .dispatch('getSitesOfSchool', school_id)
            .then((results) => (this.schoolSites = results));
        }
      },
      updateUserEmail(value) {
        if (this.user.id === value.id) {
          this.user.email = value.email;
        }
      },
    },
    async mounted() {
      this.loadSitesOfSchool();
      await this.getUserDetails();
      this.updateUserEvent();
      this.getUserCourses();
    },
    created() {},
    beforeDestroy() {
      EventBus.$off('update-userDetails-event');
    },
  };
</script>
<style lang="stylus" scoped>
  .avatar-circle
    width: 32px
    height: 32px
  .tab-title
    font-size: 18px;
    font-weight: 500;
    letter-spacing: 0.005em;
    line-height: 24px;
  .pl-headline
    font-weight bold
</style>



// WEBPACK FOOTER //
// userDetailsModal.vue?74c9b429